
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import { AtsCompany, NRClientType } from "@/lib/model/NRXQ/nr";
import { NRCandidate } from "@/lib/model/NRXQ/candidate";
import { ElForm } from "element-ui/types/form";

@Component({
  components: {}
})
export default class CVTable extends Vue {
  @Prop({ default: [], type: Array }) tableData!: [];
  showEditDialog = false;
  currentEditCv: NRCandidate | null = null;
  // @Prop({ default: 0, type: Number }) status!: number;
  // a = 0;
  // @Watch("status")
  // as(o: any, k: any) {
  //   this.a = Number(o);
  // }
  cvTitleFormRules = {
    position: [{ required: true, message: "请输入应聘岗位", trigger: "blur" }]
  };

  showSetIsNrDialog = false;
  showSetIsNrDialogStatus = 0;
  setNrCv: any = null;

  created() {
    //
  }
  mounted() {
    //
  }

  showDetail(row: any) {
    window.open(row.candidateReportUrl);
  }

  showEdit(row: any) {
    this.currentEditCv = new NRCandidate().assign(row);
    this.showEditDialog = true;
  }

  saveEdit() {
    (this.$refs.cvTitleForm as ElForm).validate(async (valid: any) => {
      if (valid && this.currentEditCv) {
        this.currentEditCv.edit(NRClientType.NRClientTypeHR).then(() => {
          this.change();
          this.$message.success("修改成功");
          this.showEditDialog = false;
          this.currentEditCv = null;
        });
      }
    });
  }

  @Emit("change")
  change() {
    //
  }

  getSubmitStatusName(i: any): string {
    let statusText = "";
    i = Number(i);
    switch (i) {
      case 0:
        statusText = "未登记";
        break;
      case 1:
        statusText = "答题中";
        break;
      case 2:
        statusText = "已交卷";
        break;
      case 3:
        statusText = "已登记";
        break;
    }
    return statusText;
  }

  auditStatusConvert(auditStatus: any) {
    auditStatus = Number(auditStatus);
    if (auditStatus === 0) {
      return "待评估";
    } else if (auditStatus === 1) {
      return "通过";
    } else if (auditStatus === 2) {
      return "待定";
    } else if (auditStatus === 3) {
      return "拒绝";
    } else {
      return "待评估";
    }
  }
  openUrl(url: string) {
    window.open(url);
  }
}
